/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { TabBarBodyLayout } from '@veeam-vspc/shared/components';

import { ExtComponent } from '../../components/Ext/ExtComponent';

export const SecurityMfaPage: React.FC<{}> = () => {
    const xtype = 'configuration.security.mfa';

    return (
        <TabBarBodyLayout>
            <ExtComponent
                xtype={xtype}
            />
        </TabBarBodyLayout>
    );
};
